<template>
	<div>
		<i v-if="loading" class="fa fa-cog fa-spin" style="font-size: 50px"></i>

		<section v-if="!loading" class="forms">
			<div class="page-header">
				<h3 class="page-title">
					{{ location.name }}
				</h3>

				<nav aria-label="breadcrumb">
					<ol class="breadcrumb">
						<li class="breadcrumb-item">
							<router-link :to="{ name: 'locations' }"
								>Einrichtungen</router-link
							>
						</li>
						<li class="breadcrumb-item active" aria-current="page">Detail</li>
					</ol>
				</nav>
			</div>

			<div
				v-if="location.notice && location.notice.length > 0"
				class="alert alert-primary"
				role="alert"
			>
				{{ location.notice }}
			</div>

			<div
				v-if="last_login"
				style="font-size: 11px; display: block; margin-bottom: 10px"
			>
				Letzter Login: {{ last_login.updated_at | moment(' D.MM.YYYY hh:mm') }}
			</div>
			<div class="row stat-row">
				<div class="col-stat stretch-card grid-margin">
					<div
						class="card stat-card bg-gradient-danger card-img-holder text-white"
					>
						<div class="card-body">
							<h4 class="font-weight-normal mb-2">
								Aktive Kinder
								<i class="mdi mdi-human-child mdi-18px float-right"></i>
							</h4>
							<h2 class="">{{ childs_count }}</h2>
							<h6 class="card-text"></h6>
						</div>
					</div>
				</div>
				<div class="col-stat stretch-card grid-margin">
					<div
						class="card stat-card bg-gradient-warning card-img-holder text-white"
					>
						<div class="card-body">
							<h4 class="font-weight-normal mb-2">
								Alle Kinder
								<i class="mdi mdi-human-child mdi-18px float-right"></i>
							</h4>
							<h2 class="">{{ inactive_childs_count }}</h2>
							<h6 class="card-text"></h6>
						</div>
					</div>
				</div>
				<div class="col-stat stretch-card grid-margin">
					<div
						class="card stat-card bg-gradient-info card-img-holder text-white"
					>
						<div class="card-body">
							<h4 class="font-weight-normal mb-2">
								Mitarbeiter
								<i
									class="mdi mdi-clipboard-account-outline mdi-18px float-right"
								></i>
							</h4>
							<h2 class="">{{ staff_count }}</h2>
							<h6 class="card-text"></h6>
						</div>
					</div>
				</div>
				<div class="col-stat stretch-card grid-margin">
					<div
						class="card stat-card bg-gradient-success card-img-holder text-white"
					>
						<div class="card-body">
							<h4 class="font-weight-normal mb-2">
								App Nutzer
								<i class="mdi mdi-cellphone-text mdi-18px float-right"></i>
							</h4>
							<h2 class="">{{ users_count }}</h2>
							<h6 class="card-text"></h6>
						</div>
					</div>
				</div>
				<div class="col-stat stretch-card grid-margin">
					<div
						class="card stat-card card-img-holder text-white"
						:class="
							flutter_app_first_seen_at
								? 'bg-gradient-primary'
								: 'bg-gradient-secondary'
						"
					>
						<div class="card-body">
							<h4 class="font-weight-normal mb-2">
								Flutter App
								<i class="mdi mdi-tablet-cellphone mdi-18px float-right"></i>
							</h4>
							<template v-if="flutter_app_first_seen_at">
								<h6
									class="card-text flutter-line"
									:title="
										'Im Einsatz seit ' +
										moment(flutter_app_first_seen_at).format('D.MM.YYYY hh:mm')
									"
								>
									Seit
									{{ flutter_app_first_seen_at | moment(' D.MM.YYYY') }}
								</h6>
								<h6
									class="card-text flutter-line"
									:title="
										'Zuletzt aktiv ' +
										moment(flutter_app_last_seen_at).format('D.MM.YYYY hh:mm')
									"
								>
									Aktiv
									{{ flutter_app_last_seen_at | moment(' D.MM.YYYY') }}
								</h6>
								<h6 v-if="flutter_app_version" class="card-text flutter-line">
									Version {{ flutter_app_version }}
								</h6>
							</template>
							<h6 v-else class="card-text flutter-line">Noch nicht im Einsatz</h6>
						</div>
					</div>
				</div>
			</div>

			<!-- Nur bei Unterlizenzierung anzeigen (mehr aktive Kinder als abgerechnet); ok/under/unknown bewusst ausgeblendet -->
			<div class="row" v-if="billing_check && billing_check.status === 'over'">
				<div class="col-md-12 stretch-card grid-margin">
					<div
						class="card billing-check-card card-img-holder text-white bg-gradient-danger"
					>
						<div class="card-body">
							<h4 class="font-weight-normal mb-3">
								Abrechnungs-Check
								<i class="mdi mdi-scale-balance mdi-18px float-right"></i>
							</h4>
							<div class="billing-check-figures">
								<div class="billing-figure">
									<span class="billing-figure-value">{{
										billing_check.childs_count
									}}</span>
									<span class="billing-figure-label">Aktive Kinder</span>
								</div>
								<div class="billing-figure">
									<span class="billing-figure-value">{{
										billing_check.billed_childs
									}}</span>
									<span class="billing-figure-label"
										>Abgerechnete Kinderzahl</span
									>
								</div>
								<div class="billing-figure">
									<span class="billing-figure-value">{{
										billing_check.diff
									}}</span>
									<span class="billing-figure-label">Differenz</span>
								</div>
								<div class="billing-figure">
									<span class="billing-figure-value"
										>Mehr aktive als abgerechnete Kinder</span
									>
									<span class="billing-figure-label">Status</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-12 stretch-card grid-margin">
					<div class="card">
						<div class="card-body">
							<h4 class="card-title"></h4>
							<b-tabs>
								<b-tab title="Account" active>
									<div class="card">
										<div class="card-body">
											<h4 class="card-title">
												Account [{{ location.kindy_id }}]
											</h4>
											<a
												:href="'https://' + location.subdomain + '.kindy.cloud'"
												target="_blank"
												>{{ location.subdomain }}.kindy.cloud</a
											>
											<div>{{ location.slot }}</div>

											<p class="card-description"></p>

											<div style="text-align: right">
												<b-button
													v-if="!loading_account"
													@click="btnLocation($event)"
													type="submit"
													variant="success"
													class="mr-2"
													>Speichern</b-button
												>
											</div>

											<form class="forms-sample">
												<b-form-group label="Tags" label-for="input1">
													<b-form-tags
														input-id="tags-basic"
														placeholder=""
														v-model="location.account_tags"
													></b-form-tags>
													<!--<p class="mt-2">Value: {{ location.tags }}</p> -->
												</b-form-group>

												<b-form-group label="Anmerkung" label-for="input1">
													<b-form-input
														v-model="location.notice"
														type="text"
														id="input1"
														placeholder="Anmerkung"
													></b-form-input>
												</b-form-group>
												<b-form-group label="Standort" label-for="input1">
													<b-form-input
														v-model="location.name"
														type="text"
														id="input1"
														placeholder="Standort"
													></b-form-input>
												</b-form-group>
												<b-form-group label="Kategorie" label-for="inputCategory">
													<b-form-input
														v-model="location.category"
														type="text"
														id="inputCategory"
														placeholder="Kategorie"
													></b-form-input>
												</b-form-group>

												<b-form-group
													label="Rechnungs Alert"
													label-for="input11alert"
												>
													<b-form-select
														v-model="location.billing_alert"
														:options="options_billingalert"
													/>
												</b-form-group>
												<b-form-group label="Status" label-for="input11">
													<b-form-select
														v-model="location.account_state"
														:options="options_state"
													/>
												</b-form-group>
												<b-form-group
													label="Testzeitraum bis"
													label-for="input113"
													v-if="location.account_state == 'test'"
												>
													<date-picker
														v-model="location.test_until"
														valueType="format"
														:format="dateFormat"
														placeholder="Datum wählen"
													></date-picker>
												</b-form-group>
												<b-form-group
													label="Kunde seit"
													label-for="input115"
													v-if="location.account_state == 'customer'"
												>
													<date-picker
														v-model="location.customer_until"
														valueType="format"
														:format="dateFormat"
														placeholder="Datum wählen"
													></date-picker>
												</b-form-group>
												<b-form-group
													label="Kündigung zum"
													label-for="input115"
													v-if="location.account_state == 'customer'"
												>
													<date-picker
														v-model="location.cancellation_at"
														valueType="format"
														:format="dateFormat"
														placeholder="Datum wählen"
													></date-picker>
												</b-form-group>
												<b-form-group label="Kindy ID" label-for="input4">
													<b-form-input
														v-model="location.kindy_id"
														type="text"
														id="input4"
														placeholder="Kindy ID"
													></b-form-input>
												</b-form-group>

												<b-form-group label="Subdomain" label-for="input6">
													<b-form-input
														v-model="location.subdomain"
														type="text"
														id="input6"
														placeholder="Subdomain"
													></b-form-input>
												</b-form-group>
												<b-form-group label="Adresse" label-for="input3">
													<b-form-input
														v-model="location.address"
														type="text"
														id="input3"
														placeholder="Adresse"
													></b-form-input>
												</b-form-group>
												<b-form-group label="E-Mail" label-for="input9">
													<b-form-input
														v-model="location.email"
														type="text"
														id="input9"
														placeholder="E-Mail"
													></b-form-input>
												</b-form-group>
												<b-form-group label="Telefonnummer" label-for="input7">
													<b-form-input
														v-model="location.phone"
														type="text"
														id="input7"
														placeholder="Telefonnummer"
													></b-form-input>
												</b-form-group>

												<b-form-group
													label="Feature Mode"
													label-for="inputFeatureMode"
												>
													<b-form-checkbox
														v-model="location.feature_mode"
														id="inputFeatureMode"
														:value="true"
														:unchecked-value="false"
														switch
													>
														{{
															location.feature_mode
																? 'Aktiviert'
																: 'Deaktiviert'
														}}
													</b-form-checkbox>
												</b-form-group>

												<div style="text-align: right">
													<b-button
														v-if="!loading_account"
														@click="btnLocation($event)"
														type="submit"
														variant="success"
														class="mr-2"
														>Speichern</b-button
													>
												</div>
											</form>
										</div>
									</div>
								</b-tab>
								<b-tab title="Stammdaten">
									<div class="card">
										<div class="card-body">
											<h4 class="card-title">Stammdaten</h4>
											<p class="card-description"></p>
											<form class="forms-sample">
												<b-form-group label="Notizen" label-for="inputC10">
													<b-form-textarea
														v-model="location_base.notes"
														id="inputC10"
														placeholder="Notizen"
														:rows="10"
													></b-form-textarea>
												</b-form-group>
												<div class="row">
													<div class="col-md-6">
														<b-form-group
															label="Nächste Abrechnung"
															label-for="input115"
															v-if="location.account_state == 'customer'"
														>
															<date-picker
																v-model="location_base.next_settlement"
																valueType="format"
																:format="dateFormat"
																placeholder="Datum wählen"
															></date-picker>
														</b-form-group>
													</div>
													<div class="col-md-6">
														<b-form-group
															label="SEPA-Lastschriftmandat"
															label-for="input11alert"
														>
															<b-form-select
																v-model="location_base.billing_sepa"
																:options="options_billingalert"
															/>
														</b-form-group>
													</div>
												</div>
												<div class="row">
													<div class="col-md-6">
														<b-form-group
															label="Rabatt (%)"
															label-for="inputCT1"
														>
															<b-form-input
																v-model="location_base.discount"
																type="text"
																id="inputCT1"
																placeholder="0"
															></b-form-input>
														</b-form-group>
													</div>
													<div class="col-md-6">
														<b-form-group
															label="Abrechnung Laufzeit in Monaten"
															label-for="inputCT2"
														>
															<b-form-input
																v-model="location_base.duration"
																type="text"
																id="inputCT2"
																placeholder="1"
															></b-form-input>
														</b-form-group>
													</div>
												</div>
												<div
													class="mt-2 mb-4"
													style="width: 100%;border-top: 1px solid #666666;"
												></div>
												<h5 class="mt-3 mb-3">Anschrift</h5>
												<b-form-group label="Einrichtung" label-for="inputC3">
													<b-form-input
														v-model="location_base.name"
														type="text"
														id="inputC3"
														placeholder="Einrichtung"
													></b-form-input>
												</b-form-group>

												<div class="row">
													<div class="col-md-4">
														<b-form-group
															label="Firmenname"
															label-for="inputC2"
														>
															<b-form-input
																v-model="location_base.company"
																type="text"
																id="inputC2"
																placeholder="Firmenname"
															></b-form-input>
														</b-form-group>
													</div>
													<div class="col-md-4">
														<b-form-group label="Nachname" label-for="inputC2">
															<b-form-input
																v-model="location_base.lastname"
																type="text"
																id="inputC2"
																placeholder="Nachname"
															></b-form-input>
														</b-form-group>
													</div>
													<div class="col-md-4">
														<b-form-group label="Name" label-for="inputC1">
															<b-form-input
																v-model="location_base.firstname"
																type="text"
																id="inputC1"
																placeholder="Name"
															></b-form-input>
														</b-form-group>
													</div>
												</div>
												<div class="row">
													<div class="col-md-4">
														<b-form-group label="Zusatz 1" label-for="inputC2">
															<b-form-input
																v-model="location_base.lineOne"
																type="text"
																placeholder="Zusatz 1"
															></b-form-input>
														</b-form-group>
													</div>
													<div class="col-md-4">
														<b-form-group label="Zusatz 2" label-for="inputC1">
															<b-form-input
																v-model="location_base.lineTwo"
																type="text"
																placeholder="Zusatz 2"
															></b-form-input>
														</b-form-group>
													</div>
													<div class="col-md-4">
														<b-form-group label="Zusatz 3" label-for="inputC4">
															<b-form-input
																v-model="location_base.lineThree"
																type="text"
																placeholder="Zusatz 3"
															></b-form-input>
														</b-form-group>
													</div>
												</div>

												<div class="row">
													<div class="col-md-6">
														<b-form-group label="Straße" label-for="inputC4">
															<b-form-input
																v-model="location_base.street"
																type="text"
																id="inputC4"
																placeholder="Straße"
															></b-form-input>
														</b-form-group>
													</div>
													<div class="col-md-6"></div>
												</div>
												<div class="row">
													<div class="col-md-6">
														<b-form-group label="PLZ" label-for="inputC5">
															<b-form-input
																v-model="location_base.zip"
																type="text"
																id="inputC5"
																placeholder="PLZ"
															></b-form-input>
														</b-form-group>
													</div>
													<div class="col-md-6">
														<b-form-group label="Ort" label-for="inputC6">
															<b-form-input
																v-model="location_base.city"
																type="text"
																id="inputC6"
																placeholder="Ort"
															></b-form-input>
														</b-form-group>
													</div>
												</div>
												<div class="row">
													<div class="col-md-6">
														<b-form-group
															label="Rechnungsadresse für PDF"
															label-for="inputC6"
														>
															<b-form-textarea
																v-model="location_base.billing_address"
																id="inputC10"
																placeholder="Rechnungsadresse"
																:rows="4"
															></b-form-textarea>
														</b-form-group>
													</div>
													<div class="col-md-6">
														<b-form-group
															label="Rechnungs E-Mail"
															label-for="inputC7"
														>
															<b-form-input
																v-model="location_base.email"
																type="text"
																id="inputC7"
																placeholder="E-Mail"
															></b-form-input>
														</b-form-group>
													</div>
												</div>
												<div
													class="mt-2 mb-4"
													style="width: 100%;border-top: 1px solid #666666;"
												></div>
												<h5 class="mt-3 mb-3">Lastschrift</h5>
												<div class="row">
													<div class="col-md-4">
														<b-form-group
															label="Lastschriftmandat"
															label-for="inputCT5"
														>
															<b-form-input
																v-model="location_base.sepa"
																type="text"
																id="inputCT5"
																placeholder="Mandat"
															></b-form-input>
														</b-form-group>
													</div>
													<div class="col-md-4">
														<b-form-group label="IBAN" label-for="inputCT6">
															<b-form-input
																v-model="location_base.iban"
																type="text"
																id="inputCT6"
																placeholder="DEXXXX"
															></b-form-input>
														</b-form-group>
													</div>
													<div class="col-md-4">
														<b-form-group
															label="Mandatsdatum"
															label-for="inputSepaDate"
														>
															<b-form-input
																v-model="location_base.sepa_mandate_date"
																type="date"
																id="inputSepaDate"
															></b-form-input>
														</b-form-group>
													</div>
												</div>
												<b-button
													v-if="!loading_base"
													@click="btnLocationBase($event)"
													type="submit"
													variant="success"
													class="mr-2"
													>Speichern</b-button
												>
											</form>
										</div>
									</div>
								</b-tab>
								<b-tab title="Dokumente">
									<vue-dropzone
										ref="imgDropZone1"
										id="customdropzone1"
										:options="dropzoneOptions1"
										@vdropzone-complete="afterComplete"
										@vdropzone-success="afterSuccess"
									></vue-dropzone>

									<div class="table-responsive">
										<table class="table">
											<thead>
												<tr>
													<th>Name</th>

													<th></th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="item in documents" :key="item.uid">
													<td>{{ item.created_at | moment(' D.MM.YYYY') }}</td>
													<td>{{ item.file_name }}</td>
													<td style="text-align: right">
														<a
															:href="item.file"
															target="_blank"
															class="btn btn-outline-primary btn-fw"
															>Download</a
														>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</b-tab>
								<b-tab title="Produkte">
									<b-button
										style="margin-bottom: 20px"
										@click="
											openModalProduct({
												product_id: 0,
												amout: 0,
											})
										"
										variant="success"
										v-b-modal.modalmd9
										class="mr-2"
										>Neues Produkt</b-button
									>
									<div class="table-responsive">
										<table class="table">
											<thead>
												<tr>
													<th>Bezeichnung</th>
													<th>Preis</th>
													<th>Anzahl</th>
													<th></th>

													<th></th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="item in products" :key="item.uid">
													<td>{{ item.name }}</td>
													<td>{{ item.price }} Euro</td>
													<td>{{ item.amout }}</td>
													<td>
														<!-- Modal starts -->
														<div class="text-center">
															<b-btn
																v-b-modal.modalmd9
																variant="primary"
																@click="openModalProduct(item)"
																>Details</b-btn
															>
														</div>
													</td>

													<td style="text-align: right">
														<!--  <router-link class="btn btn-outline-primary btn-fw" :to="{ name: 'location-detail', params: { uid: item.uid }}" >Anzeigen</router-link> -->
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</b-tab>
								<b-tab title="Rechnungen">
									<b-button
										style="margin-bottom: 20px"
										@click="btnAddBilling($event)"
										type="submit"
										variant="success"
										class="mr-2"
										>Neue Rechnung</b-button
									>

									<div class="alert alert-primary" v-show="create_pdf_loader">
										Erstelle PDF ...
									</div>

									<div class="table-responsive">
										<table class="table">
											<thead>
												<tr>
													<th>Re-Nr.</th>
													<th>Datum</th>
													<th>Zeitraum</th>

													<th>Netto</th>
													<th>Brutto</th>
													<th>Bezahlt</th>
													<th>E-Mail</th>
													<th>Erinnerung</th>
													<th></th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="item in billings" :key="item.uid">
													<td>
														<i
															@click="generatePdf(item)"
															style="cursor: pointer; margin-right: 5px"
															class="mdi mdi-file-pdf mdi-24px"
														></i>
														<i
															v-if="hasValidSepaMandate() && canDownloadSepaXml(item)"
															@click="downloadSepaXml(item)"
															style="cursor: pointer; margin-right: 5px"
															class="mdi mdi-bank mdi-24px"
															title="SEPA XML für Money Money"
														></i>
														<span v-if="!item.download_file">{{
															item.invoice_nr
														}}</span>
														<a
															v-if="item.download_file"
															:href="item.download_file"
															target="_blank"
															>{{ item.invoice_nr }}</a
														>
													</td>
													<td>{{ item.invoice_date }}</td>
													<td>
														{{ item.invoice_range_from }}<br />{{
															item.invoice_range_to
														}}
													</td>

													<td>
														<span v-if="item.cancel_invoice" style="color: red"
															>-
															{{
																(item.invoice_amount / 100) | toCurrency
															}}</span
														>
														<span
															v-if="!item.cancel_invoice"
															style="color: green"
														>
															{{
																(item.invoice_amount / 100) | toCurrency
															}}</span
														>
													</td>

													<td>
														<span v-if="item.cancel_invoice" style="color: red"
															>-
															{{
																((item.invoice_amount / 100) * 1.19)
																	| toCurrency
															}}</span
														>
														<span
															v-if="!item.cancel_invoice"
															style="color: green"
														>
															{{
																((item.invoice_amount / 100) * 1.19)
																	| toCurrency
															}}</span
														>
													</td>

													<td>
														<!-- #1116: storniertes Original bleibt paid:false, ist aber nicht offen -->
														<div
															v-if="invoiceState(item) === 'cancelled'"
															style="color: red"
														>
															{{ cancelledLabel(item) }}
															<br />
															{{ item.cancelled_at }}
														</div>
														<div v-else-if="item.paid">
															<span v-if="item.cancel_invoice"
																>Storno RE-{{ item.cancel_invoice_nr }}</span
															>
															<span v-if="!item.cancel_invoice">Ja</span>
															<br />
															{{ item.paid_at }}
														</div>
													</td>
													<td>
														<div v-if="item.emailsend">
															Ja<br />
															{{ item.emailsend_at }}
														</div>
													</td>
													<td>
														<b-btn
															v-if="canSendPaymentReminder(item)"
															variant="outline-warning"
															size="sm"
															@click="sendPaymentReminder(item)"
															>Zahlungserinnerung senden</b-btn
														>
														<div
															v-if="item.reminder_send_at"
															style="
																font-size: 12px;
																color: #7f8fa4;
																margin-top: 4px;
															"
														>
															zuletzt erinnert am
															{{ item.reminder_send_at
															}}<span v-if="item.reminder_count">
																({{ item.reminder_count }}x)</span
															>
														</div>
													</td>
													<td>
														<div
															v-for="tag in item.tags"
															:key="tag"
															class="badge-container"
														>
															<span class="badge-tag">{{ tag }}</span>
														</div>
													</td>
													<td style="text-align: right">
														<!-- Modal starts -->
														<div class="text-center">
															<b-btn
																variant="primary sm"
																@click="openModal(item)"
																>Details</b-btn
															>
														</div>
													</td>
												</tr>
											</tbody>
										</table>

										<invoice-details-modal
											ref="invoiceModal"
											modal-id="modalmd"
											:default-receiver="location_base.email || ''"
											@busy="create_pdf_loader = $event"
											@billings="billings = $event"
											@sent="onInvoiceSent"
										></invoice-details-modal>

										<b-modal id="modalmd9" title="Produkte" size="md" ok-only @>
											<form class="forms-sample">
												<b-form-group label="Status" label-for="input11">
													<b-form-select
														v-model="current_item.product_id"
														:options="product_list_dp"
													/>
												</b-form-group>

												<b-form-group label="Anzahl" label-for="input4">
													<b-form-input
														v-model="current_item.amout"
														type="text"
														id="input4"
														placeholder="Anzahl"
													></b-form-input>
												</b-form-group>

												<b-button
													variant="success"
													@click="saveProductDetails()"
													class="mr-2"
													>Speichern</b-button
												>
												<b-button @click="removeProductDetails()" class="mr-2"
													>Löschen</b-button
												>
											</form>
										</b-modal>

										<!-- Modal Ends -->
									</div>
								</b-tab>
								<b-tab title="Ablage">
									<vue-dropzone
										ref="imgDropZone2"
										id="customdropzone2"
										:options="dropzoneOptions2"
										@vdropzone-complete="afterComplete"
										@vdropzone-success="afterSuccess"
									></vue-dropzone>

									<div class="table-responsive">
										<table class="table">
											<thead>
												<tr>
													<th>Name</th>

													<th></th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="item in invoices" :key="item.uid">
													<td>{{ item.created_at | moment(' D.MM.YYYY') }}</td>
													<td>{{ item.file_name }}</td>
													<td style="text-align: right">
														<a
															:href="item.file"
															target="_blank"
															class="btn btn-outline-primary btn-fw"
															>Download</a
														>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</b-tab>
								<b-tab title="Mitarbeiter">
									<table class="table">
										<thead>
											<tr>
												<th>Vorname</th>
												<th>Nachname</th>
												<th>Zugangsart</th>
												<th>E-Mail</th>
												<th>Status</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="item in staff_list" :key="item.uid">
												<td>
													{{ item.firstname }}
													<!--
                          <div v-if="location.kenc">
                            <a target="_blank"
                              :href="'http://www.kindy.app/unmask-test-call?slot=' + location.slot + '&str=' + encodeURIComponent(item.firstname)">Unmask</a>
                          </div>
                          -->
												</td>
												<td>
													{{ item.lastname }}
												</td>
												<td>
													<b-form-select
														v-model="item.access_type"
														:options="options_pin"
														@change="updatePin(item)"
														size="sm"
														style="max-width: 150px;"
													></b-form-select>
												</td>
												<td>
													<b-form-input
														v-model="item.email"
														type="email"
														size="sm"
														style="max-width: 220px;"
														@focus="emailBeforeEdit = item.email"
														@change="updateStaffEmail(item)"
													></b-form-input>
												</td>
												<td>
													<div>
														<span
															class="badge"
															:class="item.employment_active === false ? 'badge-danger' : 'badge-success'"
														>{{ item.employment_active === false ? 'Inaktiv' : 'Aktiv' }}</span>
													</div>
													<b-button
														v-if="item.employment_active === false"
														size="sm"
														variant="outline-success"
														class="mt-1"
														@click="setStaffEmploymentActive(item, true)"
													>Aktivieren</b-button>
													<b-button
														v-else
														size="sm"
														variant="outline-danger"
														class="mt-1"
														@click="setStaffEmploymentActive(item, false)"
													>Deaktivieren</b-button>
													<div
														v-if="item.employment_active_changed_at"
														class="text-muted mt-1"
														style="font-size: 11px; line-height: 1.3;"
													>
														Geändert am
														{{ moment(item.employment_active_changed_at).format('DD.MM.YYYY HH:mm') }}
														von {{ resolveChangedBy(item.employment_active_changed_by) }}
													</div>
												</td>
												<td>
													<span v-if="item.access_type == 'email_pin'">{{
														item.activated
													}}</span>
												</td>
											</tr>
										</tbody>
									</table>
								</b-tab>
							</b-tabs>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script lang="js">

import Vue from 'vue';
import moment from 'moment';

import dropzone from 'vue2-dropzone';
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/de';
import InvoiceDetailsModal from '@/components/InvoiceDetailsModal.vue';
import { isPastPaymentTerm, invoiceState, cancelledLabel } from '@/utils/invoice';

// Ablehnungen von /admin/invoice/sepa-xml (HTTP 400, message) in Klartext
const SEPA_ERROR_TEXTS = {
  'invoice cancelled': 'Die Rechnung ist storniert, es wird keine Lastschrift erzeugt.',
  'invoice is a cancellation': 'Das ist ein Storno-Beleg, es wird keine Lastschrift erzeugt.'
};

// Ablehnungsgruende von send-payment-reminder (data.reason) in Klartext;
// unbekannte Gruende erscheinen wie bisher roh
const REMINDER_REASON_TEXTS = {
  cancelled: 'Rechnung ist storniert'
};

// https://github.com/rowanwins/vue-dropzone

//let uuid = require("uuid");
import {
  getLocation,
  updateLocation,
  sendPaymentReminder,
  getLocationDocuments,
  addBilling,
  updateProduct,
  createPdf,
  updateLocationBase,
  updateStaffAccess,
  updateStaffEmail,
  updateStaffEmploymentActive,
  downloadSepaXml
} from '@/services/locations.service';

export default {
  name: 'basicFormsElements',
  components: {
    DatePicker,
    InvoiceDetailsModal,
    vueDropzone: dropzone
  },
  data() {
    return {
      current_item: {},
      file: null,
      create_pdf_loader: false,
      location: {},
      products: [],
      childs_count: 0,
      inactive_childs_count: 0,
      users_count: 0,
      staff_count: 0,
      billing_check: null,
      documents: [],
      invoices: [],
      billings: [],
      last_login: null,
      flutter_app_first_seen_at: null,
      flutter_app_last_seen_at: null,
      flutter_app_version: null,
      staff_list: [],
      emailBeforeEdit: '',
      loading: true,
      location_base: {},
      loading_account: false,
      loading_base: false,
      dateFormat: 'DD.MM.YYYY',
      options_billingalert: [
        { value: 'n', text: 'Nein' },
        { value: 'y', text: 'Ja' }

        //{ value: 'd', text: 'This one is disabled', disabled: true }
      ],
      options_state: [
        { value: null, text: '' },
        { value: 'test', text: 'Test' },
        { value: 'customer', text: 'Kunde' },
        { text: "Kostenlose Nutzung", value: "forfree" },
        { value: 'close', text: 'Geschlossen' },
        //{ value: 'd', text: 'This one is disabled', disabled: true }
      ],
      options_pin: [
        { value: 'pin', text: 'PIN' },
        { value: 'email_pin', text: 'E-Mail PIN' }
      ],
      dropzoneOptions1: {
        url: Vue.prototype.$apiBase + "/admin/locations/upload-document",
        //thumbnailWidth: 150,
        //thumbnailHeight: 150,
        headers: { "x-access-token": localStorage.getItem('token') },
        addRemoveLinks: false,
        params: { 'cat': 'document' },
        acceptedFiles: ".jpg, .jpeg, .png, .pdf",
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Drag File or Click Here</p>
          `
      },
      dropzoneOptions2: {
        url: Vue.prototype.$apiBase + "/admin/locations/upload-document",
        //thumbnailWidth: 150,
        //thumbnailHeight: 150,
        headers: { "x-access-token": localStorage.getItem('token') },
        addRemoveLinks: false,
        params: { 'cat': 'invoice' },
        acceptedFiles: ".jpg, .jpeg, .png, .pdf",
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Drag File or Click Here</p>
          `
      },
    }
  },
  computed: {
    document_list: function () {
      return this.$store.state.locations
    },
    product_list_dp: function () {

      let m = []

      for (let k = 0; k < this.$store.state.allProducts.length; k++) {

        m.push(
          { value: this.$store.state.allProducts[k].product_id, text: this.$store.state.allProducts[k].name + " (" + this.$store.state.allProducts[k].price / 100 + ")" }
        )

      }

      return m

    }
  },
  mounted() {

    this.loading = true

    getLocation(this.$route.params.uid).then((resp) => {

      if (resp.data.error) {
        if (resp.data.error == 'location') {
          this.$router.push({ name: 'locations' })
        }

        if (resp.data.error == 'user') {
          localStorage.removeItem('token')
          this.$router.push({ name: 'login' })
        }
      }
      else {

        console.log("resp", resp.data)

        this.location = resp.data.location


        if (this.location.created_at) {
          this.location.created_at = moment(this.location.created_at).format('DD.MM.YYYY');
        }

        this.dropzoneOptions1.params.loc_id = this.location.loc_id
        this.dropzoneOptions2.params.loc_id = this.location.loc_id

        this.dropzoneOptions1.params.location_uid = this.$route.params.uid
        this.dropzoneOptions2.params.location_uid = this.$route.params.uid

        this.location_base = resp.data.location_base

        this.childs_count = resp.data.childs_count
        this.inactive_childs_count = resp.data.childs_inactive_count
        this.staff_count = resp.data.staff_count
        this.users_count = resp.data.users_count

        this.last_login = resp.data.last_login

        this.flutter_app_first_seen_at = this.location.flutter_app_first_seen_at
        this.flutter_app_last_seen_at = this.location.flutter_app_last_seen_at
        this.flutter_app_version = this.location.flutter_app_version

        this.billings = resp.data.billings

        // Abrechnungs-Check: additives Feld, null fuer Nicht-Kunden-Accounts.
        this.billing_check = resp.data.billing_check

        this.products = resp.data.products

        this.$store.state.allProducts = resp.data.all_products

        this.invoices = resp.data.entries_invoices
        this.documents = resp.data.entries_documents

        this.staff_list = resp.data.staff_list

        this.loading = false
      }

    }).catch(() => {
      localStorage.removeItem("token");
      this.$router.push({ name: "login" });
    });




  },
  methods: {
    invoiceState,
    cancelledLabel,
    // #1116: kein Lastschrifteinzug fuer Storno-Beleg und storniertes
    // Original; der Server lehnt beides mit HTTP 400 ab.
    canDownloadSepaXml(item) {
      const state = invoiceState(item)
      return state !== 'storno' && state !== 'cancelled'
    },
    hasValidSepaMandate() {
      const b = this.location_base || {}
      return !!(b.sepa && b.iban && b.sepa_mandate_date)
    },
    downloadSepaXml(item) {
      downloadSepaXml({ invoice_id: item._id, invoice_nr: item.invoice_nr })
        .catch((err) => {
          const serverMsg =
            err && err.response && err.response.data && err.response.data.message
          const msg =
            SEPA_ERROR_TEXTS[serverMsg] || serverMsg || 'SEPA-XML konnte nicht erzeugt werden'
          if (this.$bvToast) {
            this.$bvToast.toast(msg, { title: 'Fehler', variant: 'danger' })
          } else {
            alert(msg)
          }
        })
    },
    generatePdf: function (item) {


      this.create_pdf_loader = true

      createPdf(item).then(data => {

        this.billings = data.data.billings
        this.create_pdf_loader = false
      })
    },
    // #879: Versanddatum aus dem Rechnungsdialog auf die Tabellenzeile
    // spiegeln. Nach einem vorherigen "Speichern" ist this.billings vom Server
    // neu geladen, deshalb die Zeile ueber _id suchen.
    onInvoiceSent: function (payload) {
      const row = (this.billings || []).find((b) => b && b._id === payload.invoice._id)
      if (row) {
        this.$set(row, 'emailsend_at', payload.emailsend_at)
        this.$set(row, 'emailsend', true)
      }
    },
    // Erinnerung nur fuer: offen, nicht storniert, kein SEPA (Rechnung ODER
    // aktuelles Standort-Mandat), Rechnung mindestens 30 Tage alt.
    // Server-Guards spiegeln jede dieser Bedingungen.
    canSendPaymentReminder: function (item) {
      if (invoiceState(item) !== 'open') return false
      if (item.sepa || this.location_base.sepa) return false
      // ohne parsebares Datum (null) entscheidet der Server-Guard
      return isPastPaymentTerm(item) !== false
    },
    sendPaymentReminder: function (item) {
      let ref = this
      const prefill = item.email || this.location_base.email || ''

      // SEPA-Rechnungen erreichen diesen Dialog nicht (Button ausgeblendet,
      // Server-Guard reason 'sepa') — Lastschrift wird eingezogen
      let infoHtml =
        '<p style="margin-bottom:8px;">Es wird eine Zahlungserinnerung als externe E-Mail versendet. Empfänger (mehrere kommagetrennt möglich):</p>'

      if (item.reminder_send_at) {
        infoHtml +=
          '<p style="color:#7F8FA4; font-size:13px; margin-top:8px;">Zuletzt erinnert am ' +
          item.reminder_send_at +
          (item.reminder_count ? ' (' + item.reminder_count + 'x)' : '') +
          '</p>'
      }

      this.$swal({
        title: 'Zahlungserinnerung senden',
        html: infoHtml,
        input: 'text',
        inputValue: prefill,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#30b3f6',
        cancelButtonColor: '#7F8FA4',
        cancelButtonText: 'Abbrechen',
        confirmButtonText: 'Erinnerung senden',
        inputValidator: (value) => {
          if (!value || !String(value).trim()) {
            return 'Bitte eine E-Mail-Adresse angeben'
          }
        }
      }).then((result) => {
        if (!result.value) {
          return
        }

        sendPaymentReminder({
          email: result.value,
          id: item._id,
          location_uid: item.location_uid
        })
          .then((data) => {
            const res = (data && data.data) || {}

            if (res.status === 'error') {
              ref.$toast.error(
                'Zahlungserinnerung konnte nicht versendet werden' +
                  (res.reason
                    ? ' (' + (REMINDER_REASON_TEXTS[res.reason] || res.reason) + ')'
                    : '')
              )
              return
            }

            // Zeile ohne Reload aus der Antwort aktualisieren
            if (res.reminder_send_at !== undefined) {
              ref.$set(item, 'reminder_send_at', res.reminder_send_at)
            }
            if (res.reminder_count !== undefined) {
              ref.$set(item, 'reminder_count', res.reminder_count)
            }

            ref.$toast.success('Zahlungserinnerung versendet')
          })
          .catch((err) => {
            const msg =
              (err && err.message) ||
              (err &&
                err.response &&
                err.response.data &&
                err.response.data.message) ||
              'Zahlungserinnerung konnte nicht versendet werden'
            ref.$toast.error(msg)
          })
      })
    },
    removeProductDetails: function () {

      updateProduct({ remove: true, location_uid: this.location.uid, item: this.current_item }).then((resp) => {

        if (resp.data && resp.data.products) {
          this.products = resp.data.products
        }
      })

    },
    saveProductDetails: function () {

      updateProduct({ location_uid: this.location.uid, item: this.current_item }).then((resp) => {
        console.log()
        if (resp.data && resp.data.products) {
          this.products = resp.data.products
        }


      })

    },
    openModalProduct: function (item) {


      this.current_item = item
    },

    openModal: function (item) {
      this.$refs.invoiceModal.open(item)
    },
    btnAddBilling: function (ev) {
      ev.preventDefault()

      addBilling({ location_uid: this.location.uid }).then((resp) => {
        console.log(resp)
        this.billings = resp.data.billings
      })
    },
    openAccount: function () {
      window.open("https://" + this.location.subdomain + ".kindy.cloud?email=hallo", "_blank");
    },
    btnLocation: function (ev) {
      ev.preventDefault()
      this.loading_account = true
      updateLocation(this.location).then(() => {
        Vue.$toast.open({
          message: 'Gespeichert',
          type: 'success',
          position: 'bottom',
          duration: 1500
        });
        this.loading_account = false
      })
    },
    btnLocationBase: function (ev) {
      ev.preventDefault()

      this.location_base.location_uid = this.$route.params.uid

      if (this.location_base.next_settlement) {
        this.location_base.next_settlement_stamp = moment(this.location_base.next_settlement, "DD.MM.YYYY").format()
      }


      this.loading_base = true
      updateLocationBase(this.location_base).then(() => {
        Vue.$toast.open({
          message: 'Gespeichert',
          type: 'success',
          position: 'bottom',
          duration: 1500
        });
        this.loading_base = false
      })
    },
    async afterSuccess(file, response) {
      console.log(file, response.data.cat)

      getLocationDocuments({
        loc_id: this.location.loc_id,
        location_uid: this.$route.params.uid,
        cat: response.data.cat
      }).then((data) => {

        if (data.data.cat == 'document') {
          this.documents = data.data.entries
        }
        if (data.data.cat == 'invoice') {
          this.invoices = data.data.entries
        }

      })

    },
    async afterComplete(upload) {
      //var imageName = uuid.v1();
      this.isLoading = true;
      try {
        //save image
        //let file = upload;
        //console.log(file)

        //var storageRef = firebase.storage().ref();
        //var imageRef = storageRef.child(`images/${imageName}.png`);
        //await imageRef.put(file, metadata);
        //var downloadURL = await imageRef.getDownloadURL();
        //this.images.push({ src: downloadURL });
      } catch (error) {
        console.log(error);
      }
      this.$refs.imgDropZone1.removeFile(upload);
      this.$refs.imgDropZone2.removeFile(upload);
    },
    updatePin: function(staffItem) {
      updateStaffAccess({
        location_uid: this.location.uid,
        staff_uid: staffItem.uid,
        access_type: staffItem.access_type
      }).then((resp) => {
        if (resp.data && resp.data.staff_list) {
          this.staff_list = resp.data.staff_list
        }
        Vue.$toast.open({
          message: 'Zugangsart aktualisiert',
          type: 'success',
          position: 'bottom',
          duration: 1500
        });
      }).catch((error) => {
        Vue.$toast.open({
          message: 'Fehler beim Aktualisieren der Zugangsart',
          type: 'error',
          position: 'bottom',
          duration: 2000
        });
        console.error('Error updating access type:', error);
      })
    },
    updateStaffEmail: function(staffItem) {
      // Vorher-Wert JETZT pinnen: emailBeforeEdit ist ein geteiltes Feld und
      // kann bis zum Fehler-Callback schon von einer anderen Zeile stammen
      const emailBefore = this.emailBeforeEdit
      updateStaffEmail({
        location_uid: this.location.uid,
        staff_uid: staffItem.uid,
        email: staffItem.email
      }).then((resp) => {
        if (resp.data && resp.data.staff) {
          staffItem.email = resp.data.staff.email
        }
        Vue.$toast.open({
          message: 'E-Mail aktualisiert',
          type: 'success',
          position: 'bottom',
          duration: 1500
        });
      }).catch((error) => {
        staffItem.email = emailBefore
        Vue.$toast.open({
          message: (error && error.message) || 'Fehler beim Aktualisieren der E-Mail',
          type: 'error',
          position: 'bottom',
          duration: 2500
        });
        console.error('Error updating staff email:', error);
      })
    },
    // changed_by aufloesen: "adminpanel:"-Praefix -> Kindy-Support,
    // uid eines staff_list-Eintrags -> Vorname Nachname, sonst Rohwert.
    resolveChangedBy: function(changedBy) {
      if (!changedBy) {
        return ''
      }
      if (String(changedBy).indexOf('adminpanel:') === 0) {
        return 'Kindy-Support'
      }
      const match = (this.staff_list || []).find((s) => s.uid === changedBy)
      if (match) {
        return [match.firstname, match.lastname].filter(Boolean).join(' ').trim() || changedBy
      }
      return changedBy
    },
    setStaffEmploymentActive: function(staffItem, nextActive) {
      // Deaktivieren beendet aktive Sitzungen -> Bestaetigung; Aktivieren ohne Dialog.
      if (nextActive === false) {
        this.$swal({
          title: 'Mitarbeiter deaktivieren?',
          text: 'Der Zugang wird deaktiviert und alle aktiven Sitzungen dieses Mitarbeiters werden sofort beendet.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#ff3b30',
          cancelButtonColor: '#7F8FA4',
          cancelButtonText: 'Abbrechen',
          confirmButtonText: 'Ja, deaktivieren'
        }).then((result) => {
          if (result.value) {
            this.applyStaffEmploymentActive(staffItem, false)
          }
        })
      } else {
        this.applyStaffEmploymentActive(staffItem, true)
      }
    },
    applyStaffEmploymentActive: function(staffItem, nextActive) {
      updateStaffEmploymentActive({
        location_uid: this.location.uid,
        staff_uid: staffItem.uid,
        employment_active: nextActive === true
      }).then((resp) => {
        const data = (resp && resp.data) || {}
        // Vue-2-Reaktivitaet: employment_active existiert evtl. noch nicht als Key
        Vue.set(staffItem, 'employment_active', data.employment_active)
        Vue.set(staffItem, 'employment_active_changed_at', data.employment_active_changed_at)
        Vue.set(staffItem, 'employment_active_changed_by', data.employment_active_changed_by)
        Vue.$toast.open({
          message: nextActive === true ? 'Mitarbeiter aktiviert' : 'Mitarbeiter deaktiviert',
          type: 'success',
          position: 'bottom',
          duration: 1500
        });
      }).catch((error) => {
        // Alter Zustand bleibt stehen (kein lokales Update im Fehlerfall)
        Vue.$toast.open({
          message: (error && error.message) || 'Status konnte nicht geändert werden',
          type: 'error',
          position: 'bottom',
          duration: 2500
        });
        console.error('Error updating staff employment_active:', error);
      })
    }
  }
}
</script>

<style scoped>
.dropzone {
	margin-bottom: 50px;
	min-height: auto !important;
}

/* Stat-Card-Reihe: 5 Cards auf Desktop in EINER Zeile, kompakter. */
.stat-row .col-stat {
	flex: 0 0 20%;
	max-width: 20%;
}

.stat-row .stat-card .card-body {
	padding: 0.9rem 1rem;
}

.stat-row .stat-card h4 {
	font-size: 0.85rem;
	line-height: 1.2;
}

.stat-row .stat-card h2 {
	font-size: 1.6rem;
	margin-bottom: 0;
}

/* Flutter-App-Card: kompakte, einheitliche Zeilenhöhe. */
.stat-row .stat-card .flutter-line {
	font-size: 0.72rem;
	line-height: 1.25;
	margin-bottom: 0.15rem;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

/* Abrechnungs-Check: konkrete Zahlen nebeneinander im Gradient-Card-Stil. */
.billing-check-card .card-body {
	padding: 1rem 1.25rem;
}

.billing-check-figures {
	display: flex;
	flex-wrap: wrap;
	gap: 1.5rem 2.5rem;
}

.billing-figure {
	display: flex;
	flex-direction: column;
}

.billing-figure-value {
	font-size: 1.5rem;
	font-weight: 600;
	line-height: 1.2;
}

.billing-figure-label {
	font-size: 0.75rem;
	opacity: 0.85;
}

/* Auf schmalen Viewports (< md) Umbruch zulassen. */
@media (max-width: 767.98px) {
	.stat-row .col-stat {
		flex: 0 0 50%;
		max-width: 50%;
	}
}

@media (max-width: 479.98px) {
	.stat-row .col-stat {
		flex: 0 0 100%;
		max-width: 100%;
	}
}
</style>

<style>
.badge-secondary {
	background-color: #198ae3;
	border-color: #198ae3;
	font-size: 13px;

	color: #ffffff;
	padding: 7px 14px 10px 12px;
}

.badge-secondary .text-truncate {
	margin-right: 5px;
}

.b-form-tag {
	font-size: 14px;
}

.badge-container {
	margin-bottom: 5px;
}

.badge-tag {
	color: #ffffff;
	background-color: #198ae3;
	padding: 4px 5px 4px 5px;
	font-size: 12px;
	display: inline-block;
}
</style>
